
















import { AxiosError } from 'axios';
import { PropType, defineComponent } from '@vue/composition-api';
import {
  useNamespacedActions,
  createNamespacedHelpers,
  useStore
} from 'vuex-composition-helpers';
import { useQuoteCreateSalesforceOpportunity } from '@/composable/quote';
import { setErrorFromAxiosError } from '@/utils/helpers';

import { IRootState } from '@/store';
import { IQuoteActions } from '@/store/quote';

import { IQuote } from '@/models';

import AlTooltipBtn from '../common/AlTooltipBtn.vue';

export default defineComponent({
  name: 'QuoteCreateSalesOpportunityListItem',

  components: {
    AlTooltipBtn
  },

  props: {
    quote: { type: Object as PropType<IQuote>, required: true }
  },

  setup(props) {
    const store = useStore<IRootState>();

    const { useActions: useSnackbarActions } = createNamespacedHelpers(
      store,
      'snackbar'
    );
    const { createSnack } = useSnackbarActions(['createSnack']);

    const quoteActions = useNamespacedActions<IQuoteActions>(store, 'quote', [
      'setQuoteField'
    ]);

    const { isLoading, mutate } = useQuoteCreateSalesforceOpportunity();

    function createSalesOpportunity() {
      mutate(props.quote.number!, {
        onSuccess: data => {
          quoteActions.setQuoteField({
            id: props.quote.number!,
            field: 'salesforce_opportunity_id',
            data: data.salesforce_opportunity_id
          });
          createSnack({
            color: 'success darken-1',
            type: 'success',
            right: true,
            useBtn: false,
            msg: 'Salesforce Opportunity created successfully.',
            btnText: 'Ok',
            timeout: 6000
          });
        },
        onError: err => {
          const error = setErrorFromAxiosError(err as AxiosError);

          createSnack({
            color: 'error',
            type: 'error',
            right: true,
            useBtn: false,
            msg: `Salesforce Opportunity failed: ${error.detail ||
              error.message}`,
            btnText: 'Ok',
            timeout: 6000
          });
        }
      });
    }

    return {
      isLoading,
      createSalesOpportunity
    };
  }
});
